import { SyntaxHighlighter } from '@/components/ui/syntax-highlighter';
import * as React from 'react';
export default {
  SyntaxHighlighter,
  React
};